import React, { useState } from 'react';
import axios from 'axios';
import { Download, Loader, CheckCircle } from 'lucide-react';
import { mensajeDeError } from '../utils/errores';

const API = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/v1/inventario/exportar/`;

/**
 * La ferretería se lleva sus datos.
 *
 * Existe porque la política de privacidad y la carta de autorización lo
 * prometen: el negocio obtiene una copia completa de lo que cargó sin pedírsela
 * a nadie. Que el botón esté acá y no escondido en un menú es parte de la
 * promesa.
 *
 * La descarga no puede ser un enlace común porque el endpoint exige la cabecera
 * de autenticación. Se pide el archivo, se lo convierte en una dirección
 * temporal del navegador y se la activa.
 */
export default function ExportarDatos() {
    const [generando, setGenerando] = useState(false);
    const [listo, setListo] = useState(null);
    const [error, setError] = useState(null);

    const descargar = async () => {
        setGenerando(true);
        setError(null);
        setListo(null);
        try {
            const respuesta = await axios.get(API, { responseType: 'blob' });

            const nombre = (respuesta.headers['content-disposition'] || '')
                .match(/filename="?([^"]+)"?/)?.[1] || 'datos.zip';

            const url = window.URL.createObjectURL(respuesta.data);
            const enlace = document.createElement('a');
            enlace.href = url;
            enlace.download = nombre;
            document.body.appendChild(enlace);
            enlace.click();
            enlace.remove();
            window.URL.revokeObjectURL(url);

            setListo(nombre);
        } catch (e) {
            setError(mensajeDeError(e, 'No se pudo generar la copia de los datos.'));
        } finally {
            setGenerando(false);
        }
    };

    return (
        <div className="p-4 rounded-2xl bg-slate-100 dark:bg-white/5">
            <p className="text-sm font-bold text-slate-700 dark:text-slate-200">
                Descargar una copia de tus datos
            </p>
            <p className="ayuda-campo">
                Un archivo con todo lo que cargaste: artículos, clientes, proveedores,
                ventas, compras y comprobantes. Viene en planillas que se abren con Excel.
                Son tus datos y podés llevártelos cuando quieras, sin pedir permiso.
            </p>

            <button
                type="button"
                onClick={descargar}
                disabled={generando}
                className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-brand-500 text-negro-950 font-bold text-sm disabled:opacity-60"
            >
                {generando
                    ? <><Loader size={15} className="animate-spin" /> Preparando el archivo…</>
                    : <><Download size={15} /> Descargar mis datos</>}
            </button>

            {listo && (
                <p className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-exito-700 dark:text-exito-400">
                    <CheckCircle size={15} /> Se descargó {listo}
                </p>
            )}
            {error && (
                <p className="mt-2 text-sm font-semibold text-error-700 dark:text-error-400">
                    {error}
                </p>
            )}
        </div>
    );
}
